/**
 * Convert pixel sizes to rems
 */
export default function pxToRem(pixelSize: number, remSize = 16): string {
  return `${pixelSize / remSize}`;
}
